import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { GroupBranchComponent } from './group-branch/group-branch.component';

import { GroupCreateBranchComponent } from './group-create-branch/group-create-branch.component';

import { GroupCreateTicketComponent } from './group-create-ticket/group-create-ticket.component';
import { GroupMyTicketComponent } from './group-my-ticket/group-my-ticket.component';

import { GroupProfileComponent } from './group-profile/group-profile.component';
import { GroupTicketDetailsComponent } from './group-ticket-details/group-ticket-details.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'group-profile', component: GroupProfileComponent, pathMatch: 'full' },
       { path: 'group-branch', component: GroupBranchComponent, pathMatch: 'full' },
       { path: 'group-create-branch', component: GroupCreateBranchComponent, pathMatch: 'full' },      
       { path: 'group-create-ticket', component: GroupCreateTicketComponent, pathMatch: 'full' },
       { path: 'group-my-ticket', component: GroupMyTicketComponent, pathMatch: 'full' },
       { path: 'group-ticket-details', component: GroupTicketDetailsComponent, pathMatch: 'full' },

    ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupadminRoutingModule { }
